var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.88 13.92L27.5733 19.4933C26.4533 24.3067 24.24 26.2533 20.08 25.8533C19.4133 25.8 18.6933 25.68 17.92 25.4933L15.68 24.96C10.12 23.64 8.4 20.8933 9.70667 15.32L11.0133 9.73333C11.28 8.6 11.6 7.61333 12 6.8C13.56 3.57333 16.2133 2.70667 20.6667 3.76L22.8933 4.28C28.48 5.58667 30.1867 8.34667 28.88 13.92V13.92Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8533 11.3733L23.32 13.0133M15.5467 16.5333L19.4133 17.52M20.08 25.8533C19.2533 26.4133 18.2133 26.88 16.9467 27.2933L14.84 27.9867C9.54666 29.6933 6.76 28.2667 5.04 22.9733L3.33333 17.7067C1.62666 12.4133 3.04 9.61333 8.33333 7.90667L10.44 7.21333C10.9867 7.04 11.5067 6.89333 12 6.8C11.6 7.61333 11.28 8.6 11.0133 9.73333L9.70666 15.32C8.4 20.8933 10.12 23.64 15.68 24.96L17.92 25.4933C18.6933 25.68 19.4133 25.8 20.08 25.8533V25.8533Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.4dd978512da3fc5cdd88ee7ebb7da36a.svg";
export { ForwardRef as ReactComponent };